<div>
  <icn-sidebar-nav [items]="navigationItems"></icn-sidebar-nav>

  <!-- Left side of the screen -->
  <scheduler-aside
    [showLibraryItemMenuButtons]="showLibraryItemMenuButtons"
  ></scheduler-aside>

  <!-- Filter -->
  <filter [ngClass]="{ showMenu: filterOpen, hideMenu: !filterOpen }"></filter>

  <div
    class="close-curtain"
    (click)="closeFilter($event)"
    *ngIf="filterOpen"
  ></div>

  <!-- Right side of screen -->
  <router-outlet></router-outlet>

  <div class="upload-media-add-contract-modal" *ngIf="showPopover">
    <div class="close-btn" (click)="showPopover = false">
      <i class="fa fa-close"> </i>
    </div>
    <div class="triangle-with-shadow"></div>
    <div class="upload-media-add-contract-header">UPLOAD/ADD ASSETS</div>
    <div class="upload-media-add-contract-description">
      You can upload files or add placeholder <br />
      contracts (empty assets) to your media panel
    </div>
    <div class="select-upload-or-add-container">
      <div class="select-header">SELECT:</div>
      <icn-dropdown
        class="select-upload-or-add-drowdown"
        [position]="bottom"
        [(selectedValue)]="uploadOrAdd"
        [textAlign]="'left'"
      >
        <icn-dropdown-item
          title="Upload files"
          [value]="'Upload'"
        ></icn-dropdown-item>
        <icn-dropdown-item
          title="Add contract"
          [value]="'Add'"
        ></icn-dropdown-item>
      </icn-dropdown>
    </div>
    <div
      class="upload-add-button"
      (click)="
        uploadOrAdd === 'Add' ? addContract() : fileInput.nativeElement.click()
      "
    >
      {{ uploadOrAdd }}
    </div>
    <input
      #fileInput
      *ngIf="uploadOrAdd === 'Upload'"
      type="file"
      (change)="onUploadFileChange($event)"
      multiple
      accept="image/*,video/*,audio/*,application/mxf,
               .aaf,.3gp,.gif,.asf,.avchd,.avi,.bik,.cam,.collab,.dat,.dsh,.dvr-ms,.flv,.m1v,
               .m2v,.fla,.flr,.sol,.m4v,.mkv,.wrap,.mng,.mov,.mpeg,.mpg,.mpe,.mp4,.mxf,.roq,
               .nsv,.ogg,.rm,.svi,.smi,.smk,.swf,.wmv,.wtv,.yuv,.webm,
               .jpg,.jpeg,.exif,.tiff,.tif,.gif,.bmp,.png,.ppm,.pgm,.pbm,.pnm,.webp,.rgbe,
               .heif,.bpg,.ico,.xisf,
               .3gp, .aa, .aac, .aax, .act, .aiff, .amr, .ape, .au, .awb,
               .dct, .dss, .dvf, .flac, .gsm, .iklax, .ivs, .m4a, .m4b, .m4p, .mmf,
               .mp3, .mpc, .msv, .oga, .mogg, .opus, .ra, .rm, .raw, .sln, .tta,
               .vox, .wav, .wma, .wv"
    />
  </div>
  <ngx-smart-modal
    #createBlockModal
    identifier="createBlockModal"
    [@.disabled]="true"
  >
    <evrideo-block-show-modal></evrideo-block-show-modal>
  </ngx-smart-modal>
</div>
